import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const styles = {
  card: {
    width: 'fit-content',
    marginRight: '8px',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  cardDataInside: {
    display: 'flex',
    width: '150px',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
    color: '#fff',
  },
};

class CardData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagInput: false,
      inputTagValue: '',
    };
  }

  render() {
    const { classes, label, data, AvatarIcon, color, hide } = this.props;
    if (hide) return null;
    return (
      <Card className={classes.card} elevation={0}>
        <CardContent>
          <div className={classes.cardDataInside}>
            <div>
              <Avatar
                className={classes.avatar}
                style={{ backgroundColor: color }}
              >
                {typeof AvatarIcon !== 'string' ? <AvatarIcon /> : AvatarIcon}
              </Avatar>
            </div>
            <div>
              <Typography variant="h5">{data}</Typography>
              <Typography variant="caption" color="textSecondary">
                {label}
              </Typography>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(CardData);
